export var isOfType = function (entity, type) {
  var _a, _b, _c;
  return entity.typeLabel === type || ((_a = entity.type) === null || _a === void 0 ? void 0 : _a.slug) === type || ((_c = (_b = entity.types) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.slug) === type;
};